<div class="container" *ngIf="accountList.length > 0; else none">
  <div class="item" *ngFor="let account of accountList; index as i">
    <div class="thirdparty">
      <img [src]="account?.icon" class="icon" />
      <div class="thirdparty-text">
        {{ "word.channel_" + account?.channel | translate }}
      </div>
    </div>
    <div class="account">
      {{ account?.username }}
    </div>
    <div class="syn-time" *ngIf="account?.syn_time">
      {{ "order.synced_an_hour_ago" | translate: { time: account?.syn_time } }}
    </div>
    <div class="syn-time" *ngIf="!account?.syn_time">
      -
    </div>
    <div
      [ngClass]="{
        action: !account?.action?.disabled,
        disabled: account?.action?.disabled
      }"
      (click)="synchronise(i)"
    >
      {{ account?.action?.text }}
    </div>
  </div>
</div>
<ng-template #none>
  <div class="none">
    <img class="host-no-data-img-large" src="/assets/icon/no_data.png" />
    <div class="title">
      <!-- 暂无可读取账号，请前往渠道直连管理页面添加 -->
      {{ "order.no_account_can_be_read" | translate }}
    </div>
  </div>
</ng-template>
